import React from "react";

const config = require("../../../config.json")
const client = config.APP_CLIENT;
const compagnyColorPrimary = config.APP_COMPAGNYCOLORPRIMARY;

const imgSocial = {
  paddingRight: "10px",
  objectFit: "contain",
  width: "15px",
  height: "15px"
};
const PhoneLink = {
  textDecoration: "none",
  color: compagnyColorPrimary,
  paddingRigth: "5px",
  marginRigth: "5px",
  lineHeight: "0",
};

export default function Instagram(instagram) {
  return (
    <>
      <a href={`${instagram.instagram}`}
        style={PhoneLink}
      >
        <img style={imgSocial} src={`https://files.myclientisrich.com/signatures_mcir/v2/icons/instagram.png`} alt="logo" width="15px" height="15px"></img>
      </a>
      <br />
    </>
  );
}
